export const BASE_URL = process.env.REACT_APP_API_ENDPOINT

export const AUTHENTICATION = {
    GET_USER_INFO: `${BASE_URL}/account/getUser`,
    AUTH_LOGIN: `${BASE_URL}/api/login`,
    AUTH_LOGOUT: `${BASE_URL}/api/logout`,
    AUTH_REGISTER: `${BASE_URL}/register/save`,
    GET_USERS: `${BASE_URL}/account/getUsers`,
};

// Hive marketplace access flow. Request access (any user) + master-admin
// grant/revoke console. URL convention: /access/{action}.
export const ACCESS = {
    REQUEST: `${BASE_URL}/access/requestAccess`,
    MY_REQUESTS: `${BASE_URL}/access/myRequests`,
    REQUESTS: `${BASE_URL}/access/requests`,
    USERS: `${BASE_URL}/access/users`,
    GRANT: `${BASE_URL}/access/grant`,
    REVOKE: `${BASE_URL}/access/revoke`,
    DENY: `${BASE_URL}/access/deny`,
    CREATE_USER: `${BASE_URL}/access/createUser`,
    UPDATE_USER: `${BASE_URL}/access/updateUser`,
    DELETE_USER: `${BASE_URL}/access/deleteUser`,
};

// Hive Spaces (data scope + sharing). URL convention: /space/{action}.
export const SPACE = {
    LIST: `${BASE_URL}/space/list`,
    CREATE: `${BASE_URL}/space/create`,
    INVITE: `${BASE_URL}/space/invite`,
    MEMBERS: `${BASE_URL}/space/members`,
    RENAME: `${BASE_URL}/space/rename`,
    REMOVE_MEMBER: `${BASE_URL}/space/removeMember`,
    UPDATE_ROLE: `${BASE_URL}/space/updateMemberRole`,
    DELETE: `${BASE_URL}/space/deleteSpace`,
    PENDING_INVITES: `${BASE_URL}/space/pendingInvites`,
    ACCEPT_INVITE: `${BASE_URL}/space/acceptInvite`,
    DECLINE_INVITE: `${BASE_URL}/space/declineInvite`,
};

// El Campesino — Recipe Cost module (Master List, migration, analytics).
// URL convention: /recipeCost/{action} (Grails default UrlMappings).
export const RECIPE_COST = {
    LIST_INGREDIENTS: `${BASE_URL}/recipeCost/listIngredients`,
    SAVE_INGREDIENT: `${BASE_URL}/recipeCost/saveIngredient`,
    DELETE_INGREDIENT: `${BASE_URL}/recipeCost/deleteIngredient`,
    SEED_INGREDIENTS: `${BASE_URL}/recipeCost/seedIngredients`,
    LIST_RECIPES: `${BASE_URL}/recipeCost/listRecipes`,
    SAVE_RECIPES: `${BASE_URL}/recipeCost/saveRecipes`,
    SAVE_CATALOG: `${BASE_URL}/recipeCost/saveCatalog`,
    BACKUP_RECIPES: `${BASE_URL}/recipeCost/backupRecipes`,
    APPLY_MIGRATION: `${BASE_URL}/recipeCost/applyMigration`,
    REVERT_MIGRATION: `${BASE_URL}/recipeCost/revertMigration`,
    ANALYTICS: `${BASE_URL}/recipeCost/analytics`,
};

export const USER_MANAGEMENT = {
    FIND_USERS: `${BASE_URL}/team/fetchLinkedUsers`,
    UPDATE_USER: `${BASE_URL}/team/update`,
    DELETE_USER: `${BASE_URL}/team/delete`,
    GET_ROLES: `${BASE_URL}/team/getRoles`,
};
export const DASHBOARD = {
    LIST_FOLDERS: `${BASE_URL}/dashboardFolder/list`,
};

export const DASHBOARD_FOLDER = {
    LIST: `${BASE_URL}/dashboardFolder/list`,
    SAVE: `${BASE_URL}/dashboardFolder/save`,
    DELETE: `${BASE_URL}/dashboardFolder/delete`,
    UPDATE_ORDER: `${BASE_URL}/dashboardFolder/updateOrder`,
};

export const FILE_PREVIEW = {
    PREVIEW_PDF: `${BASE_URL}/folder/previewPDF`,
};

export const FOLDER = {
    LIST: `${BASE_URL}/folder/list`,
    GLOBAL_SEARCH: `${BASE_URL}/folder/globalSearch`,
    DUPLICATE_FOLDER: `${BASE_URL}/folder/duplicateFolder`,
    RENAME_NODE: `${BASE_URL}/folder/renameNode`,
    PASTE_ITEM: `${BASE_URL}/folder/pasteItem`,
    UPLOAD_FILE: `${BASE_URL}/folder/uploadFile`,
    CREATE_FOLDER: `${BASE_URL}/folder/createFolder`,
    DELETE_TEMPORARY_NODE: `${BASE_URL}/folder/deleteTemporaryNode`,
    RECYCLE_BIN: `${BASE_URL}/folder/recycleBin`,
    RESTORE_NODE: `${BASE_URL}/folder/restoreNode`,
    PERMANENTLY_DELETE_NODE: `${BASE_URL}/folder/permanentlyDeleteNode`,
};

export const TODO = {
    LIST: `${BASE_URL}/todo/list`,
    SAVE: `${BASE_URL}/todo/save`,
    UPDATE: `${BASE_URL}/todo/update`,
    DELETE: `${BASE_URL}/todo/delete`,
    PREVIEW_ATTACHMENT: `${BASE_URL}/todo/previewAttachmentFile`,
};

export const LOCATION = {
    LIST: `${BASE_URL}/location/list`,
    SAVE_LOCATION: `${BASE_URL}/location/saveLocation`,
    RENAME_LOCATION: `${BASE_URL}/location/renameLocation`,
    ARCHIVE_LOCATION: `${BASE_URL}/location/archiveLocation`,
    UNARCHIVE_LOCATION: `${BASE_URL}/location/unarchiveLocation`,
    DELETE_LOCATION: `${BASE_URL}/location/deleteLocation`,
    SAVE_INVESTOR: `${BASE_URL}/location/saveInvestor`,
    UPDATE_INVESTOR: `${BASE_URL}/location/updateInvestor`,
    DELETE_INVESTOR: `${BASE_URL}/location/deleteInvestor`,
    SAVE_SHARE_CONFIG: `${BASE_URL}/location/saveShareConfig`,
    LIST_SHARE_CONFIGS: `${BASE_URL}/location/listShareConfigs`,
    DELETE_SHARE_CONFIG: `${BASE_URL}/location/deleteShareConfig`,
    EFFECTIVE_CONFIG: `${BASE_URL}/location/effectiveConfig`,
};

export const LIZ_ACCOUNTING = {
    LOCATION_SUMMARY: `${BASE_URL}/lizAccounting/locationSummary`,
    LOCATION_WEEK_REPORT: `${BASE_URL}/lizAccounting/locationWeekReport`,
    LOCATION_YEAR_PROFIT_SUMMARY: `${BASE_URL}/lizAccounting/locationYearProfitSummary`,
    GET_WEEK: `${BASE_URL}/lizAccounting/getWeek`,
    SAVE_WEEK: `${BASE_URL}/lizAccounting/saveWeek`,
    GET_ATM_WEEK_DATA: `${BASE_URL}/lizAccounting/getATMWeekData`,
    SAVE_ATM_WEEK_DATA: `${BASE_URL}/lizAccounting/saveATMWeekData`,
    REPORT_PAYMENT: `${BASE_URL}/lizAccounting/reportPayment`,
    VERIFY_PAYMENT: `${BASE_URL}/lizAccounting/verifyPayment`,
    UNVERIFY_PAYMENT: `${BASE_URL}/lizAccounting/unverifyPayment`,
};

export const COMPANY = {
    LIST_COMPANIES: `${BASE_URL}/company/list`,
    CREATE_COMPANY: `${BASE_URL}/company/create`,
    UPDATE_COMPANY: `${BASE_URL}/company/update`,
}

export const ALERTS = {
    FETCH_ALERTS: `${BASE_URL}/alert/listAlerts`,
    SNOOZE_ALERT: `${BASE_URL}/alert/snoozeAlert`,
    RESOLVE_ALERT: `${BASE_URL}/alert/resolveAlert`,
}

export const ACCOUNT = {
    GET_USER_SETTING: `${BASE_URL}/account/getUserSetting`,
    SAVE_USER_SETTING: `${BASE_URL}/account/saveUserSetting`,
};

export const LOAN = {
    LIST_CUSTOMER_LOAN: `${BASE_URL}/loans/listCustomerLoan`,
    SAVE_CUSTOMER_LOAN: `${BASE_URL}/loans/saveCustomerLoan`,
    CREATE_BORROWER: `${BASE_URL}/loans/createBorrower`,
    EDIT_BORROWER: `${BASE_URL}/loans/editBorrower`,
    ADD_TRANSACTION: `${BASE_URL}/loans/addTransaction`,
    EDIT_TRANSACTION: `${BASE_URL}/loans/editTransaction`,
    DELETE_TRANSACTION: `${BASE_URL}/loans/deleteTransaction`,
    DELETE_BORROWER: `${BASE_URL}/loans/deleteBorrower`,
}

export const BUSINESS_TRACKER = {
    LIST_ACCOUNTS: `${BASE_URL}/businessTracker/listAccounts`,
    SAVE_ACCOUNT: `${BASE_URL}/businessTracker/saveAccount`,
    CANCEL_ACCOUNT: `${BASE_URL}/businessTracker/cancelAccount`,
    DELETE_ACCOUNT: `${BASE_URL}/businessTracker/deleteAccount`,
    SAVE_CELL: `${BASE_URL}/businessTracker/saveCell`,
}

export const INVESTOR_TRACKER = {
    LIST_ALL: `${BASE_URL}/investorTracker/listAll`,
    SAVE_PERSON: `${BASE_URL}/investorTracker/savePerson`,
    DELETE_PERSON: `${BASE_URL}/investorTracker/deletePerson`,
    SAVE_LOCATION: `${BASE_URL}/investorTracker/saveLocation`,
    DELETE_LOCATION: `${BASE_URL}/investorTracker/deleteLocation`,
    SAVE_EXPENSE: `${BASE_URL}/investorTracker/saveExpense`,
    DELETE_EXPENSE: `${BASE_URL}/investorTracker/deleteExpense`,
    SAVE_PAYMENT: `${BASE_URL}/investorTracker/savePayment`,
    DELETE_PAYMENT: `${BASE_URL}/investorTracker/deletePayment`,
    UPDATE_PAYMENT_STATUS: `${BASE_URL}/investorTracker/updatePaymentStatus`,
    UPDATE_PARTICIPATION: `${BASE_URL}/investorTracker/updateParticipation`,
    SAVE_CONTRACTOR: `${BASE_URL}/investorTracker/saveContractor`,
    DELETE_CONTRACTOR: `${BASE_URL}/investorTracker/deleteContractor`,
    SAVE_QUOTE: `${BASE_URL}/investorTracker/saveQuote`,
    DELETE_QUOTE: `${BASE_URL}/investorTracker/deleteQuote`,
    SAVE_CONTRACTOR_PAYMENT: `${BASE_URL}/investorTracker/saveContractorPayment`,
    DELETE_CONTRACTOR_PAYMENT: `${BASE_URL}/investorTracker/deleteContractorPayment`,
    SAVE_WEEKLY_PAYMENT: `${BASE_URL}/investorTracker/saveWeeklyPayment`,
    DELETE_WEEKLY_PAYMENT: `${BASE_URL}/investorTracker/deleteWeeklyPayment`,
    SAVE_SAVED_CONTRACTOR: `${BASE_URL}/investorTracker/saveSavedContractor`,
    DELETE_SAVED_CONTRACTOR: `${BASE_URL}/investorTracker/deleteSavedContractor`,
    SAVE_CONTRACTOR_CATEGORY: `${BASE_URL}/investorTracker/saveContractorCategory`,
}

export const REAL_ESTATE = {
    LIST_ALL: `${BASE_URL}/realEstate/listAll`,
    SAVE_PARTNER: `${BASE_URL}/realEstate/savePartner`,
    ADD_PARTNER: `${BASE_URL}/realEstate/addPartner`,
    DELETE_PARTNER: `${BASE_URL}/realEstate/deletePartner`,
    SAVE_HOUSE: `${BASE_URL}/realEstate/saveHouse`,
    DELETE_HOUSE: `${BASE_URL}/realEstate/deleteHouse`,
    SAVE_EXPENSE: `${BASE_URL}/realEstate/saveExpense`,
    DELETE_EXPENSE: `${BASE_URL}/realEstate/deleteExpense`,
}